<template>
  <div>
    <div class="page-header">
      <button @click="add" class="add_role">新增角色</button>
    </div>
    <div class="page-main">
      <a-table
        :pagination="pagination"
        class="table_data"
        :columns="columns"
        :dataSource="dataList"
        rowKey="roleId"
        :loading="loading"
      >
        <div slot="action" slot-scope="text, record">
          <a
            href="javascript:;"
            @click="handleUpdate(record)"
            style="margin-right: 10px; color: #2a82e4"
            >编辑</a
          >
          <a href="javascript:;" @click="handleDelete(record)" style="color: red">删除</a>
        </div>
      </a-table>
    </div>

    <a-modal
      :title="title"
      width="750px"
      :visible="visible"
      @cancel="handleCancel"
      :maskClosable="false"
      footer
    >
      <a-form-model ref="ruleForm" :model="formData" :rules="rules" v-bind="layout">
        <a-form-model-item label="角色名称">
          <a-input v-model="formData.roleName" placeholder="请输入角色名称" />
        </a-form-model-item>
        <a-form-model-item label="描述">
          <a-input v-model="formData.roleDesc" placeholder="请输入描述" />
        </a-form-model-item>
        <div class="permissions_data">
          <div class="permissions_data_header">
            <p>权限设置</p>
            <!--            <button class="permissions_data_header_save" @click="roleSave">保存</button>-->
          </div>
          <Role @role-change="roleChange" :role-value="roleValue" ref="mrole" />
        </div>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
          <div style="text-align: center; margin-top: 10px">
            <a-button style="margin-right: 10px" @click="handleCancel('ruleForm')">取消</a-button>
            <a-button type="primary" @click="handleSubmit('ruleForm')">确定</a-button>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { roledelete, roleDetail, roleList, canDelete } from "@/api/index/system";
import { menuList } from "@/config/routerConfig";
import Role from "./role";

const plainOptions = ["用户列表", "用户详情"];

const defaultCheckedList = ["用户列表"];
export default {
  components: {
    Role,
  },
  data() {
    return {
      menuList,
      columns: [
        {
          title: "角色名称",
          dataIndex: "roleName",
          key: "roleName",
          align: "center",
        },
        {
          title: "角色描述",
          dataIndex: "roleDesc",
          key: "roleDesc",
          align: "center",
        },
        {
          title: "操作",
          width: "180px",
          scopedSlots: { customRender: "action" },
          align: "center",
        },
      ],
      dataList: [],
      visible: false,
      Name: "",
      Desc: "",
      formData: {
        roleName: "",
        roleDesc: "",
      },
      rules: {
        // roleDesc: [{ required: true, message: "请输入角色描述" }],
        roleName: [{ required: true, message: "请输入角色名称" }],
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
      },
      title: "",
      checkedList: defaultCheckedList,
      indeterminate: true,
      checkAll: false,
      plainOptions,
      plainOption: ["系统管理员", "角色管理", "新增角色", "操作日志"],
      checkedLists: ["系统管理员"],

      tableConfig: {
        hideDefaultSelections: true,
        rowSelection: {
          type: "radio",
          selectedRowKeys: [],
          onChange: (selectedRowKeys) => {
            // this.tableConfig.rowSelection.selectedRowKeys = [];
            this.record = this.dataList.find((el) => el.roleId === +selectedRowKeys);
            this.tableConfig.rowSelection.selectedRowKeys = selectedRowKeys;
            this.roleInit(selectedRowKeys);
          },
        },
      },
      loading: false,
      all: {},
      allStatus: {},
      roleValue: undefined, // 接口请求完成和选择用户时都会更新
      //分页配置
      pagination: {
        total: 1,
        defaultPageSize: 10,
        showTotal:total => `共 ${total}条数据`,
        onChange: (current) => this.changePage(current),
      },
      //查询参数
      params:{
        pageNo:1,
        pageSize:10
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 初始化 this.all的数据, 可用来清空数据
    createAllItem() {
      this.menuList.forEach((el) => {
        const { auth } = el;
        if (auth) {
          this.$set(this.all, auth, []);
          this.$set(this.allStatus, auth, false);
        }
      });
    },
    // 根据 value 的 auth 给 this.all[auth]设置数据
    setAllItemValue(value) {
      // 回显数据
      // auth_name 格式
      if (!value) return false;
      this.createAllItem();
      value?.split(";")?.forEach((el) => {
        const auth = el.split("_")?.[0];
        if (!auth) return false;
        this.all[auth].push(el);
      });
    },
    // 根据id获取详情，并设置role值
    roleInit: async function (roleId) {
      if (this.loading) return false;
      this.loading = true;
      const res = await roleDetail(roleId);
      this.loading = false;
      this.roleValue = res?.resultData?.resources;
      // this.setAllItemValue(res?.resultData?.resources);
    },

    getData: async function () {
      this.loading = true;
      const res = await roleList(this.params);
      const records = res?.resultData?.records;
      this.dataList = records || [];
      const firstItem = records?.[0];
      this.tableConfig.rowSelection.selectedRowKeys = [firstItem?.roleId]; // 默认选中
      this.pagination.total =res?.resultData?.totalNum;
      //Math.ceil(res?.resultData?.totalNum / 10); 
      console.log(this.pagination);
      // this.record = firstItem; // 默认选中
      // this.roleValue = firstItem?.resources;
      // const resources = firstItem?.resources;
      // if (resources) {
      //   this.setAllItemValue(resources);
      // }
      this.loading = false;
    },

    add() {
      this.title = "新增角色";
      this.visible = true;
      this.formData = {
        roleName: "",
        roleDesc: "",
      };
    },
    handleUpdate: async function (record) {
      if (this.loading) return false;
      this.loading = true;
      this.title = "修改角色";
      const roleId = record?.roleId;
      const res = await roleDetail(roleId);
      this.loading = false;
      this.formData = res?.resultData || {};
      this.formData.roleId = roleId;

      this.roleValue = res?.resultData?.resources;
      this.visible = true;
    },
    handleDelete(e) {
      let _this = this;
      this.$confirm({
        title: "确定要删除该角色吗",
        async onOk() {
          canDelete(e.roleId)
            .then((result) => {
              if (result.resultStatus) {
                if (result.resultData.useStatus) {
                  _this.$message.warn("角色已被使用");
                  return reject();
                } else {
                  return roledelete(e.roleId);
                }
              }
            })
            //roledelete(e.roleId)
            .then((res) => {
              if (res.resultStatus) {
                _this.$message.success("删除成功");
                _this.getData();
              } else {
                _this.$message.warn(res.errorMessage);
              }
            })
            .catch((err) => {
              // _this.$message.error("请求失败");
            })
            .finally(() => {});
        },
        onCancel() {},
        class: "test",
      });
    },

    systemRoles: async function (record) {
      console.log(record);
      this.loading = true;
      const res = await this.$post(
        `bluetoothlight/web/system/roles/${record?.roleId || 0}`,
        record
      );
      const resultStatus = res?.resultStatus;
      // tips(this, resultStatus, res.errorMessage);
      if (resultStatus) {
        this.getData();
        this.handleCancel();
      }
      this.loading = false;
    },
    roleSave(payload = {}) {
      let resources = "";
      //console.log(this.formData);
      console.log(this.all);
      Object.keys(this.all).forEach((el) => {
        const role = this.all[el];

        if (!role.length) return false;
        resources += `${el};${role.toString().replace(/,/g, ";")};`;
      });

      // let resources = Object.values(this.all)?.reduce((acc, cur) => {
      //   acc = [...acc, ...cur];
      //   return acc;
      // }, [])?.toString()?.replace(/,/g, ";");
      if (!resources) {
        resources = "";
      }
      //
      this.systemRoles({ ...(this.record || {}), ...payload, resources });
    },
    handleSubmit(formName) {
      if (this.loading) return false;
      this.$refs[formName].validate(async (valid) => {
        if (!valid) return false;
        this.roleSave(this.formData);
      });
    },
    handleCancel() {
      this.Name = "";
      this.Desc = "";
      this.visible = false;
      this.loading = false;
      this.roleValue = undefined;
      this.$refs.mrole?.createAllItem();
    },
    onChange(checkedList) {
      // this.indeterminate = !!checkedList.length && checkedList.length < plainOptions.length;
      // this.checkAll = checkedList.length === plainOptions.length;
    },
    onCheckAllChange(e, index) {
      const checked = e.target.checked;
      const item = menuList?.[index];
      const auth = item?.auth;
      const children = item?.children || [];
      if (!auth) return false;
      this.all[auth] = checked ? children.map((el) => el.auth) : [];
      this.allStatus[auth] = checked;

      // Object.assign(this, {
      //   checkedList: e.target.checked ? plainOptions : [],
      //   indeterminate: false,
      //   checkAll: e.target.checked
      // });
    },
    filterData(data) {
      if (!data || !data.length) return [];
      return data.map((el) => {
        const { title, auth } = el;
        return {
          ...el,
          label: title,
          value: auth,
        };
      });
    },
    roleChange(val) {
      this.all = val;
    },
    changePage(cu){
      this.params.pageNo = cu;
      this.getData();
    }
  },
};
</script>


<style lang="less" scoped>
.role_list {
  display: flex;
  padding: 10px;
}

.add_role {
  width: 100px;
  height: 30px;
  font-size: 12px;
  border: none;
  background-color: #2a82e4;
  border-radius: 5px;
  color: #fff;
  outline: none;
}

.table_data {
  //width: 50%;
  //border-right: 5px solid #eee;
  padding-right: 10px;
  box-sizing: border-box;
  margin-top: 30px;
}

.permissions_data {
  //width: 50%;
  margin-left: 20px;
  border: 1px solid #eee;
  margin-top: 30px;

  &_header {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    height: 50px;
    line-height: 30px;
    background-color: #eee;
    padding: 10px;
    box-sizing: border-box;

    &_save {
      width: 70px;
      height: 30px;
      line-height: 30px;
      font-size: 10px;
      border: none;
      outline: none;
      border-radius: 5px;
      color: #fff;
      background-color: #2a82e4;
    }
  }
}
</style>
